import {Component, inject, OnInit, ViewEncapsulation} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {AnnouncePageComponent} from '../announce-page/announce-page.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../../environments/environment';
import {QrcodeJoinGroupModalComponent} from '../qrcode-join-group-modal/qrcode-join-group-modal.component';
import {Version, VersionService} from '../../service/version.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit{
  private router = inject(Router);
  visible: boolean = false;
  private modalService= inject(NgbModal);
  versionService = inject(VersionService)
  version: Version

  viewPassword() {
    this.visible = !this.visible;
  }
  ngOnInit() {
    this.versionService.getVersion().subscribe(e => this.version = e)
  }

  login() {
    this.router.navigate(['/welcome']);
  }

  openModal(){
    const modalRef = this.modalService.open(AnnouncePageComponent, {
      size: 'xl',
    });
  }
  register() {
    this.router.navigate(['/register']);
  }

  openQrcodeJoinGroupModal() {
    const modalRef = this.modalService.open(QrcodeJoinGroupModalComponent, {
      size: 'lg',
    });
  }
}
